<template>
  <div class="settings">
    <div class="main-wrapper">
      <layout-header></layout-header>
      <layout-sidebarPromotion></layout-sidebarPromotion>
      <!-- Page Wrapper -->
      <div class="page-wrapper">
        <!-- Page Content -->
        <div class="content container-fluid">
          <div class="row">
            <div class="col-md-8 offset-md-2">
              <!-- Page Header -->
              <div class="page-header">
                <div class="row">
                  <div class="col-sm-12">
                    <h3 class="page-title">Company Settings</h3>
                  </div>
                </div>
              </div>
              <!-- /Page Header -->

              <form>
                <div class="row">
                  <div class="col-sm-6">
                    <div class="form-group">
                      <label
                        >Company Name <span class="text-danger">*</span></label
                      >
                      <input
                        class="form-control"
                        type="text"
                        value="Dreamguy's Technologies"
                      />
                    </div>
                  </div>
                  <div class="col-sm-6">
                    <div class="form-group">
                      <label>Contact Person</label>
                      <input
                        class="form-control"
                        value="Daniel Porter"
                        type="text"
                      />
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-sm-12">
                    <div class="form-group">
                      <label>Address</label>
                      <input
                        class="form-control"
                        value="3864 Quiet Valley Lane, Sherman Oaks, CA, 91403"
                        type="text"
                      />
                    </div>
                  </div>
                  <div class="col-sm-6 col-md-6 col-lg-3">
                    <div class="form-group">
                      <label>Country</label>
                      <select class="form-control select">
                        <option>USA</option>
                        <option>United Kingdom</option>
                      </select>
                    </div>
                  </div>
                  <div class="col-sm-6 col-md-6 col-lg-3">
                    <div class="form-group">
                      <label>City</label>
                      <input
                        class="form-control"
                        value="Sherman Oaks"
                        type="text"
                      />
                    </div>
                  </div>
                  <div class="col-sm-6 col-md-6 col-lg-3">
                    <div class="form-group">
                      <label>State/Province</label>
                      <select class="form-control select">
                        <option>California</option>
                        <option>Alaska</option>
                        <option>Alabama</option>
                      </select>
                    </div>
                  </div>
                  <div class="col-sm-6 col-md-6 col-lg-3">
                    <div class="form-group">
                      <label>Postal Code</label>
                      <input class="form-control" value="91403" type="text" />
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-sm-6">
                    <div class="form-group">
                      <label>Email</label>
                      <input
                        class="form-control"
                        value="danielporter@example.com"
                        type="email"
                      />
                    </div>
                  </div>
                  <div class="col-sm-6">
                    <div class="form-group">
                      <label>Phone Number</label>
                      <input
                        class="form-control"
                        value="818-978-7102"
                        type="text"
                      />
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-sm-6">
                    <div class="form-group">
                      <label>Mobile Number</label>
                      <input
                        class="form-control"
                        value="818-635-5579"
                        type="text"
                      />
                    </div>
                  </div>
                  <div class="col-sm-6">
                    <div class="form-group">
                      <label>Fax</label>
                      <input
                        class="form-control"
                        value="818-978-7102"
                        type="text"
                      />
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-sm-12">
                    <div class="form-group">
                      <label>Website Url</label>
                      <input
                        class="form-control"
                        value="https://www.example.com"
                        type="text"
                      />
                    </div>
                  </div>
                </div>
                <div class="submit-section">
                  <button class="btn btn-primary submit-btn">Save</button>
                </div>
              </form>
            </div>
          </div>
        </div>
        <!-- /Page Content -->
      </div>
      <!-- /Page Wrapper -->
    </div>
  </div>
</template>

<script>
import LayoutHeader from "@/components/layouts/Header.vue";
import LayoutSidebarPromotion from "@/components/layouts/SidebarPromotion.vue";
export default {
  components: {
    LayoutHeader,
    LayoutSidebarPromotion,
  },
  mounted() {
    // Select 2
    if ($(".select").length > 0) {
      $(".select").select2({
        minimumResultsForSearch: -1,
        width: "100%",
      });
    }
    // Multiselect
    if ($("#customleave_select").length > 0) {
      $("#customleave_select").multiselect();
    }
    if ($("#edit_customleave_select").length > 0) {
      $("#edit_customleave_select").multiselect();
    }
    if ($(".floating").length > 0) {
      $(".floating")
        .on("focus blur", function (e) {
          $(this)
            .parents(".form-focus")
            .toggleClass(
              "focused",
              e.type === "focus" || this.value.length > 0
            );
        })
        .trigger("blur");
    }
  },
  name: "settings",
};
</script>


// WEBPACK FOOTER //
// src/components/settings.vue